import 'core-js/stable';
import { distributorApp } from './distributorApp';
import { ApplicationInitialState } from './types';
import { ApplicationOptions } from './types/applicationOptions';

export type DistributorAppInstance = ReturnType<typeof runDistributorApp>;

export const runDistributorApp = (applicationOptions: ApplicationOptions, initialState: ApplicationInitialState) => {
    __webpack_public_path__ = __LOCALHOST__
        ? '/'
        : `${applicationOptions.configuration.app.assetBaseUrl}/${__VERSION__}/`;
    return distributorApp(applicationOptions, initialState);
};

// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
global.Mews = global.Mews || {};
global.Mews.runDistributorApp = runDistributorApp;
